const routes = {
  login: "/login",
  emails: "/emails",
  forgotPassword: "/forgot_password",
  recoverPassword: "/auth/forgot-password",
  meeting: "/meeting/:token",
  webForm: "/webform/:company/:form",
  createAccount: "/create_account",
  createAccountEntel: "/create_account/entel",
  users: "/users",
  /** Panel global solo Wembii admin (dueños): métricas plataforma */
  wembiiAdminDashboard: "/admin/dashboard",
  wembiiAdminSupport: "/admin/support",
  wembiiAdminSendGridBilling: "/admin/sendgrid-billing",
  plans: "/plans",
  company: "/company",
  meCompany: "/me/company",
  editCompany: "/company/:id",
  social: "/social",
  /** Panel con estadísticas, acciones rápidas y plan (antes en la misma pantalla que Inicio) */
  homeDashboard: "/social/dashboard",
  binding: "/binding",
  socialPost: "/social/post",
  socialAutomatedPosts: "/social/automated-posts",
  aiGeneration: "/social/ai-generation",
  aiTextToImage: "/social/ai/text-to-image",
  socialStory: "/social/story",
  socialHistory: "/social/history",
  socialManager: "/social/manager",
  socialContentGrid: "/social/content-grid",
  socialCalendar: "/social/calendar",
  publicContentGrid: "/public/content-grid",
  videoGen: "/ia/video-gen",
  videoEditor: "/ia/editor-videos",
  linkedInPopUp: "/social/linkedin",
  twitterPopUp: "/social/twitter",
  tiktokPopUp: "/social/tiktok",
  googlePopUp: "/social/google",
  instagramLoginPopUp: "/social/instagram-login",
  youtubePopUp: "/social/youtube",
  googleCalendarPopUp: "/social/google/calendar",
  gmailPopUp: "/social/gmail",
  office365PopUp1: "/social/office365",
  office365PopUp2: "/social/office365/asUser",
  mercadolibrePopUp: "/social/mercadolibre",
  jumpsellerPopUp: "/social/jumpseller",
  mailchimpPopUp: "/social/mailchimp",
  wooPopUp: "/social/woo",
  analyticsSummary: "/analytics/resumen",
  facebookAnalytics: "/analytics/facebook",
  googleAnalytics: "/analytics/google",
  instagramAnalytics: "/analytics/instagram",
  tiktokAnalytics: "/analytics/tiktok",
  linkedinBusinessAnalytics: "/analytics/linkedin-business",
  youtubeAnalytics: "/analytics/youtube",
  analytics: "/analytics",
  webForms: "/form/web",
  editWebForm: "/form/web/:id",
  facebookForm: "/form/facebook",
  viewFacebookForm: "/form/facebook/:id",
  wooCommerceAnalytics: "/analytics/woocommerce",
  mercadolibreAnalytics: "/analytics/mercadolibre",
  wooCommerceOrders: "/market/woocommerce/orders",
  mercadolibreOrders: "/market/mercadolibre/orders",
  jumpsellerOrders: "/market/jumpseller/orders",
  editWebChat: "/chat/web/configuration",
  webChat: "/chat/web",
  editWhatsappChat: "/chat/whatsapp/configuration",
  facebookCampaigns: "/facebook/campaigns",
  createCampaign: "/campaign/create",
  contacts: "/contacts",
  contactCompanies: "/companies/contact",
  reports: "/reports",
  resellers: "/resellers",
  activityBoards: "/boards/activity",
  businessBoard: "/boards/business",
  tasks: "/boards/tasks",
  businessBoardAnalytics: "/boards/business/analytics",
  boards: "/boards",
  editBoards: "/boards/:id",
  calendar: "/calendar",
  automations: "/automations",
  notifications: "/notifications",
  canvaDesigner: "/canva-designer",
  whatsappAuth: "/whatsapp-auth",
  websitePages: "/website/pages",
  editWebsitePage: "/website/pages/:id",
  emailMarketingLists: "/email-marketing/lists",
  emailMarketingEmails: "/email-marketing/emails",
  emailMarketingCampaignDetail: "/email-marketing/emails/:campaignId",
  emailMarketingTemplates: "/email-marketing/templates",
  emailMarketingReports: "/email-marketing/reports",
  emailMarketingConfig: "/email-marketing/settings",
  publicWebsitePage: "/p/:company/:slug",
  previewWebsitePage: "/website/preview/:company/:id",
};

export default routes;
